<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="OT">Contents</p>
<p class="CON2" id="toc1"><a href="#/DeGroat_Toughest_People_to_Love_text2#toc_marker-2">Introduction</a></p>
<p class="CON1" id="toc2"><a href="#/DeGroat_Toughest_People_to_Love_text3#toc_marker-3">Part 1: Understanding People</a></p>
<p class="CON2" id="toc3"><a href="#/DeGroat_Toughest_People_to_Love_text4#toc_marker-4">1. A vision for those we lead, a vision for ourselves</a></p>
<p class="CON2" id="toc4"><a href="#/DeGroat_Toughest_People_to_Love_text5#toc_marker-5">2. Understanding our story</a></p>
<p class="CON1" id="toc5"><a href="#/DeGroat_Toughest_People_to_Love_text6#toc_marker-6">Part 2: Leading and Loving Difficult People</a></p>
<p class="CON2" id="toc6"><a href="#/DeGroat_Toughest_People_to_Love_text7#toc_marker-7">3. Personality disorders: loving those who drive you crazy</a></p>
<p class="CON2" id="toc7"><a href="#/DeGroat_Toughest_People_to_Love_text8#toc_marker-8">4. Addictions: loving in the dark</a></p>
<p class="CON2" id="toc8"><a href="#/DeGroat_Toughest_People_to_Love_text9#toc_marker-9">5. Loving the fool:when relationships turn ugly</a></p>
<p class="CON1" id="toc9"><a href="#/DeGroat_Toughest_People_to_Love_text10#toc_marker-10">Part 3: Dealing with Ourselves: The Best Help We Can Give Another</a></p>
<p class="CON2" id="toc10"><a href="#/DeGroat_Toughest_People_to_Love_text11#toc_marker-11">6. Growing through pain:the gift of the dark</a></p>
<p class="CON2" id="toc11"><a href="#/DeGroat_Toughest_People_to_Love_text12#toc_marker-12">7. Living with wholeness:rest and resiliency in the leader’s life</a></p>
<p class="CON2" id="toc12"><a href="#/DeGroat_Toughest_People_to_Love_text13#toc_marker-13">8. Growing into leadership maturity:self-­care and the art of shadow-­boxing</a></p>
<p class="CON2" id="toc13"><a href="#/DeGroat_Toughest_People_to_Love_text14#toc_marker-14">Benediction</a></p>
<p class="CON2" id="toc14"><a href="#/DeGroat_Toughest_People_to_Love_text15#toc_marker-15">Notes</a></p>
<p class="CON2" id="toc15"><a href="#/DeGroat_Toughest_People_to_Love_text16#toc_marker-16">Resources</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DeGroat_Toughest_People_to_Love_text-1.vue?5df78630